import { render, staticRenderFns } from "./new_home_ld.vue?vue&type=template&id=810c176a&scoped=true"
import script from "./new_home_ld.vue?vue&type=script&lang=js"
export * from "./new_home_ld.vue?vue&type=script&lang=js"
import style0 from "./new_home_ld.vue?vue&type=style&index=0&id=810c176a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810c176a",
  null
  
)

export default component.exports